import React, { useEffect, useState } from 'react'

const MobileWebViewVideo = () => {
    const [embedUrl, setEmbedUrl] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const urlFromQuery = params.get('url');
        if (urlFromQuery) {
            setEmbedUrl(urlFromQuery);
            setTimeout(() => {
                window.ReactNativeWebView?.postMessage('Video started playing')
            }, 1000);
        }
    }, []);

    if (!embedUrl) return <p>Loading...</p>;

    return (
        <div>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                <iframe
                    src={embedUrl}
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    title="Vimeo Video"
                ></iframe>
            </div>
        </div>
    );
}


export default MobileWebViewVideo